import React from 'react';

export default function MethodologySimilarLinks({ methodologyLink, similarLink }) {
    return (
        <div style={{ fontWeight: 'bold' }}>
            <a href={methodologyLink}>See Methodology&nbsp;&gt;</a><br />
            <a href={similarLink}>See Similar Institutions&nbsp;&gt;</a>
        </div >
    );
}